import produce from 'immer';
import { AnyAction } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  ADD_NFT_TO_CART,
  REMOVE_NFT_FROM_CART,
  SET_CART_LOADING,
  SET_CART_OPEN,
  UPDATE_CART_DATA
} from '../ActionTypes';
import { CURRENCY_MAP } from 'constants/app/currency-map';
import { ICartData, ICartNft } from 'interfaces';

type InitialStateType = {
  isOpen: boolean;
  loading: boolean;
  data: ICartNft[];
  info: Omit<ICartData, 'items'>;
};

export const INIT_STATE: InitialStateType = {
  isOpen: false,
  loading: false,
  data: [],
  info: {
    id: 0,
    items_count: 0,
    cart_currency_code: '',
    grand_total: '',
    formatted_grand_total: '',
    sub_total: '',
    formatted_sub_total: '',
    tax_total: '',
    formatted_tax_total: '',
    mint_amount: '',
    formatted_mint_amount: '',
    payment: '',
    created_at: '',
    updated_at: ''
  }
};

const calculateTotalPrice = (data: ICartNft[]) => {
  const _currencyCode = localStorage.getItem('currency') || 'FTN';
  const currency = CURRENCY_MAP[_currencyCode];
  const totalPrice = data
    .reduce((acc, nft) => {
      return acc + Number(nft.price);
    }, 0)
    .toFixed(2);
  return {
    sub_total: totalPrice,
    formatted_sub_total: `${currency} ${totalPrice}`
  };
};

const _CartReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case ADD_NFT_TO_CART: {
        draft.data.push(action.payload);
        draft.info = {
          ...INIT_STATE.info,
          ...calculateTotalPrice(draft.data),
          items_count: draft.data.length
        };
        break;
      }
      case REMOVE_NFT_FROM_CART: {
        draft.data = draft.data.filter(item => item.id !== action.payload);
        draft.info = {
          ...INIT_STATE.info,
          ...calculateTotalPrice(draft.data),
          items_count: draft.data.length
        };
        break;
      }
      case SET_CART_OPEN:
        draft.isOpen = action.payload;
        break;
      case SET_CART_LOADING:
        draft.loading = action.payload;
        break;
      case UPDATE_CART_DATA: {
        draft.loading = false;
        if (!action.payload) {
          draft.data = INIT_STATE.data;
          draft.info = INIT_STATE.info;
          return;
        }
        const { items, ...rest } = action.payload;
        draft.data = items;
        draft.info = rest;
        break;
      }
    }
  });

const persistConfig = {
  key: 'cart',
  storage: storage,
  blacklist: ['isOpen']
};

export const CartReducer = persistReducer(persistConfig, _CartReducer);
